// import Home from "../views/Home.vue";
// import AboutUs from "../../aboutUs/views/AboutUs.vue";
// import FAQ from "../../FAQ/views/Faq.vue";
// import ContactUs from "../../contactUs/views/ContactUs.vue";
// import UserDashboard from "../../userdashboard/views/Dashboard.vue";


const BoutiqueHome = () => import('../components/BoutiqueHome.vue');

const BecomeADealer = () => import('../components/BecomeADealer.vue');

const Dealers = () => import('../components/Dealers.vue');

const Boutique = () => import('../views/Boutique.vue');

const AboutUs = () => import('../../aboutUs/views/AboutUs.vue');

const ContactUs = () => import('../../contactUs/views/ContactUs.vue');


export default [{
        path: "/boutique/:id/:name",
        name: "Boutique",
        component: Boutique,
        children:[
            {
                path: '',
                component: BoutiqueHome,
                name:"BoutiqueHome"
            },
            {
                path: 'become-a-dealer',
                component: BecomeADealer,
                name:"BecomeADealer",
                beforeEnter: () => {
                    // <script async defer src="https://maps.googleapis.com/maps/api/js?key=AIzaSyCesypEBJ5FruuIgJUF9PiiNJC1cB-Udag&libraries=places&callback=initMap"></script>
                    // async function init(){
                    //     const gMaps = document.getElementById('gMaps')
                       
                    //     if (gMaps==null)
                    //     {
                    //         await new Promise(
                    //             (resolve)=>
                    //             {
                    //                 let googleMapsTag = document.createElement("script");
                    //                 googleMapsTag.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyCesypEBJ5FruuIgJUF9PiiNJC1cB-Udag&libraries=places&callback=initMap";
                    //                 googleMapsTag.id = 'gMaps'
                    //                 document.getElementsByTagName("head")[0].appendChild(googleMapsTag);
                    //                 googleMapsTag.onload = function(){
                    //                     resolve()
                    //                 }
                    //             }
                    //         )
                            
                    //     }
                    // }
                    
                    // init()
                },
            },
            {
                path: 'dealers',
                component: Dealers,
                name:"Dealers"
            },
            {
                path: 'about-us',
                component: AboutUs,
                name:"BoutiqueAboutUs"
            },
            {
                path: 'contact-us',
                component: ContactUs,
                name:"BoutiqueContactUs"
            },
        ]
    },
    
];